import { serializeFormData } from '../helpers/helpers';

const SENDEMAIL_SERVICE = {
  async sendEmail(form) {
    const submitBtn = form.querySelector('button[type="submit"]');
    const success = document.querySelector('#modal-send-form-message .success-message');
    const fail = document.querySelector('#modal-send-form-message .fail-message');
    const openModal = document.querySelector('button[data-modal-target="modal-send-form-message"]');

    const finish = (ok) => {
      submitBtn.classList.remove('is-loading');
      if (success) success.classList.add('hidden');
      if (fail) fail.classList.add('hidden');
      (ok ? success : fail).classList.remove('hidden');
      if (openModal) openModal.click();
    };

    // Template params — mapped from the demo form's fields.
    const data = serializeFormData(form);
    const templateParams = {
      email: data.email || '',
      name: data.name || '',
      company: data.company || '',
      role: data.role || '',
      message: data.message || '',
      terms_conditions: data.terms_conditions ? 'accepted' : '',
    };

    emailjs.init({ publicKey: process.env.EJS_API_KEY });

    return emailjs
      .send(process.env.EJS_SERVICE_ID, process.env.EJS_TEMPLATE_ID, templateParams)
      .then(() => {
        form.reset();
        finish(true);
      })
      .catch(() => {
        finish(false);
      });
  }
};

export { SENDEMAIL_SERVICE };
